import { useTranslation } from 'next-i18next'

import Link from 'next/link'

import { NAVIGATION_ICONS } from '@/constants/navigationAssets'

import {
  NavipayAdvertisementWrapper,
  NavipayTextContent
} from './NavipayAdvertisement.styled'

export default function NavipayAdvertisement() {
  const { t } = useTranslation('parkings')
  const content = t('searchNearParking.filters.navipay.content')

  const handleWrapperClick = () => {
    window.location.href = '/parkings/dubai/holiday-inn-dubai-park-fly'
  }

  return (
    <NavipayAdvertisementWrapper
      data-test-id="navipay-advertisement-wrapper"
      onClick={handleWrapperClick}
      style={{ cursor: 'pointer', position: 'relative' }}
    >
      <img
        src={NAVIGATION_ICONS.navipay}
        alt="Navipay"
        data-test-id="navipay-title"
        loading="lazy"
      />
      <NavipayTextContent data-test-id="navipay-text-content">
        {content}
      </NavipayTextContent>
      <div onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
        <Link
          href="https://apps.apple.com/pl/app/navipay/id1455350141"
          target="_blank"
          data-test-id="apple-link"
        >
          <img
            src={
              'https://cdn.naviparking.com/digital_parking/assets/appleStoreBanner.svg'
            }
            alt="appleBanner"
            data-test-id="apple-banner"
          />
        </Link>
      </div>
      <div onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
        <Link
          href="https://play.google.com/store/apps/details?id=eu.ekinnolab.navipay"
          target="_blank"
          data-test-id="google-play-link"
        >
          <img
            src={
              'https://cdn.naviparking.com/digital_parking/assets/googlePlayBanner.svg'
            }
            alt="googlePlayBanner"
            data-test-id="google-play-banner"
          />
        </Link>
      </div>
    </NavipayAdvertisementWrapper>
  )
}
